import React from "react";
import {
  DISCLAIMER_LAST_REVIEWED_DATE,
  DISCLAIMER_PARAGRAPHS,
  DISCLAIMER_VERSION,
} from "../constants/disclaimer";

function DisclaimerModal({ onAccept }) {
  return (
    <div className="disclaimer-modal-overlay" role="presentation">
      <section
        className="disclaimer-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="disclaimer-modal-title"
      >
        <h2 id="disclaimer-modal-title" className="disclaimer-modal-title">
          Important Disclaimer
        </h2>
        <div className="disclaimer-modal-content">
          {DISCLAIMER_PARAGRAPHS.map((paragraph, idx) => (
            <p key={idx}>{paragraph}</p>
          ))}
          <p>
            This page was last reviewed on {DISCLAIMER_LAST_REVIEWED_DATE}. By clicking
            <strong> I understand</strong> or otherwise actively accepting this disclaimer, you confirm that you
            have read and understood its terms.
          </p>
          <p className="disclaimer-modal-meta">
            Disclaimer version: {DISCLAIMER_VERSION}. Read the <a href="/disclaimer">full disclaimer page</a>.
          </p>
        </div>
        <div className="disclaimer-modal-actions">
          <button type="button" className="cookie-btn cookie-btn-primary" onClick={onAccept}>
            I understand
          </button>
        </div>
      </section>
    </div>
  );
}

export default DisclaimerModal;
